var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverallImpact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/overall-impact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overall-Impact",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-1248.000000, -597.000000)",
    fill: "#007DBB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1248.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-6",
    transform: "translate(0.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stats-bars",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.25,
    y: 0,
    width: 2.4375,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 9.75,
    width: 2.4375,
    height: 3.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.5,
    y: 5.6875,
    width: 2.4375,
    height: 7.3125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.75,
    y: 4.0625,
    width: 2.4375,
    height: 8.9375
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallImpact);
export default __webpack_public_path__ + "static/media/overall-impact.a4ca955462ffae5f674494470a9b9d4e.svg";
export { ForwardRef as ReactComponent };